import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import Tag from './icon-tag.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Tag {...validProps} />;
}
SvgComponent.iconName = 'tag';

export const TagIcon = svgIconWrapper(SvgComponent);
